import React, { useState, useEffect, useContext } from 'react';
import { LoginDataContext } from '@contexts/LoginDataContext';

const PreLoaderOverlay = () => {
    const [isDataOpen, setIsDataOpen] = useState(true);
    const [loginData] = useContext(LoginDataContext);
    const { isShowMemberRules } = loginData;

    useEffect(() => {
        setIsDataOpen(false);
    }, []);

    return (
        <div className="preloader preloader--overlay" data-open={isDataOpen}>
            <div className="preloader__spiner">
                <div className="preloader__circles">
                    <div className="preloader__circle-1" />
                    <div className="preloader__circle-2" />
                </div>
            </div>
        </div>
    );
};

export default PreLoaderOverlay;
